import i18n from "@/i18ns/i18n.js";
const routes = [
  {
    path: "request-list",
    component: () =>
      import(
        /* webpackChunkName:'Dashboard-Dashboard' */ "@/views/RequestList/RequestList.vue"
      ),
    children: [
      
    ],
    meta: {
      Title: "Danhh sách yêu cầu"
    }
  }
];

export default routes;
